import { render } from "./SavedLists.vue?vue&type=template&id=c9fda94c&scoped=true"
import script from "./SavedLists.vue?vue&type=script&lang=js"
export * from "./SavedLists.vue?vue&type=script&lang=js"

import "./SavedLists.vue?vue&type=style&index=0&id=c9fda94c&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9fda94c"]])

export default __exports__